import {
  Component,
  Input,
  ElementRef,
  AfterViewInit,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-script-trusted',
    templateUrl: './script-trusted.component.html',
    styleUrls: ['./script-trusted.component.scss']
})
export class ScriptTrustedComponent implements AfterViewInit {

  @Input()
    src: string;

    @Input()
    type: string;

    constructor(
      private el: ElementRef,
      @Inject(PLATFORM_ID) private platformId: Object
    ) { }

    convertToScript() {
        if (!isPlatformBrowser(this.platformId)) {
          return;
        }
        var element = this.el.nativeElement;
        var script = document.createElement("script");
        script.type = this.type ? this.type : "text/javascript";
        if (this.src) {
            script.src = this.src;
        }
        if (element.innerHTML) {
            script.innerHTML = element.innerHTML;
        }
        //var parent = element.parentElement;
        element.appendChild(script);
    }

    ngAfterViewInit() {
        this.convertToScript();
    }

}

